import { preserveItems, restorePreserved } from '../../services/util/local-storage-preserve.service';

(function() {

  'use strict';

  function PerfilRedirecionarController(Perfil, localStorageService) {

    Perfil.getUserData(true)
      .then(function(user) {
        Perfil.verificarCadastro(user);
      })
      .catch(function(err) {
        let items = preserveItems();
        //Redirecionar para o site
        localStorageService.clearAll();
        restorePreserved(items);
        window.location.href = "/";
      });

  }

  angular
    .module('mandaeApp')
    .controller('PerfilRedirecionarController', PerfilRedirecionarController);

})();
